<template>

  <div class="scheme_item">
    <b-row
      class="content-header"
    >

      <!-- Content Left -->
      <b-col
        class="content-header-left mb-2"
        cols="12"
        md="12"
      >
        <b-row class="breadcrumbs-top">
          <b-col cols="12">
            <h1 class="custom-header-title">
              Editing Entitlement Item to be Issued
            </h1>
            <p class="log_info">
              Created by {{ existScheme.createdBy ? existScheme.createdBy.name : '' }} on {{ dateFormatWithTime(existScheme.createdAt) }} <br>Last updated on {{ dateFormatWithTime(existScheme.updatedAt) }}
            </p>
          </b-col>
        </b-row>
      </b-col>
    </b-row>

    <!-- Table Container Card -->
    <b-form @submit.prevent="submitForm">
      <validation-observer
        ref="schemeCreateForm"
        #default="{invalid}"
      >
        <b-card
          header-tag="header"
        >
          <b-row>
            <b-col cols="md-12">
              <b-form-group
                label="Customer Facing Name*"
                label-for="h-scheme-name"
                label-cols-md="2"
              >
                <validation-provider
                  #default="{ errors }"
                  name="Customer Facing Name"
                  vid="name"
                  rules="required"
                >
                  <div
                    class="d-flex align-items-start"
                    style="gap: 10px;"
                  >
                    <div class="width6col">
                      <b-form-input
                        id="h-scheme-name"
                        v-model="name"
                        placeholder="Enter a name for the scheme"
                        :state="(errors.length > 0 || nameValidation) ? false : null"
                        name="name"
                        @input="nameValidation == true ? nameValidation = false : null"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                      <small
                        v-if="nameValidation"
                        class="text-danger"
                      >
                        {{ nameError }}
                      </small>
                    </div>
                  </div>
                </validation-provider>
              </b-form-group>
            </b-col>
          </b-row>

          <b-row>
            <b-col cols="md-12">
              <validation-provider
                #default="{ errors }"
                name="Entitlement Item Type"
                vid="type"
                rules="required"
              >
                <b-form-group
                  label="Entitlement Item Type*"
                  label-for="h-scheme-type"
                  label-cols-md="2"
                  :state="(errors.length > 0 || typeValidation) ? false : null"
                >
                  <div
                    class="d-flex align-items-start"
                    style="gap: 10px;"
                  >
                    <div class="width6col">
                      <v-select
                        id="h-scheme-type"
                        v-model="type"
                        label="title"
                        :options="itemTypes"
                        :reduce="title => title.code"
                        :clearable="false"
                        @input="typeValidation == true ? typeValidation = false : null"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                      <small
                        v-if="typeValidation"
                        class="text-danger"
                      >
                        {{ typeError }}
                      </small>
                    </div>
                  </div>
                </b-form-group>
              </validation-provider>
            </b-col>
          </b-row>

          <b-row
            v-if="type == 2"
          >
            <b-col cols="md-12">
              <validation-provider
                #default="{ errors }"
                name="Funeral Service Package"
                vid="funeralServicePackage"
                :rules="type === 2 ? 'required' : ''"
              >
                <b-form-group
                  label="Funeral Service Package*"
                  label-for="h-scheme-service-package"
                  label-cols-md="2"
                  :state="(errors.length > 0 || funeralServicePackageValidation) ? false : null"
                >
                  <div
                    class="d-flex align-items-start"
                    style="gap: 10px;"
                  >
                    <div class="width6col">
                      <v-select
                        id="h-scheme-service-package"
                        v-model="funeralServicePackage"
                        label="title"
                        :options="funeralServicePackages"
                        :reduce="title => title.code"
                        :clearable="false"
                        @input="funeralServicePackageValidation == true ? funeralServicePackageValidation = false : null"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                      <small
                        v-if="funeralServicePackageValidation"
                        class="text-danger"
                      >
                        {{ funeralServicePackageError }}
                      </small>
                    </div>
                  </div>
                </b-form-group>
              </validation-provider>
            </b-col>
          </b-row>

          <b-row>
            <b-col cols="md-12">
              <b-form-group
                label="Validity*"
                label-cols-md="2"
              >
                <div
                  class="d-flex align-items-start"
                  style="gap: 10px;"
                >

                  <div
                    class="width6col d-flex"
                    style="gap: 10px;"
                  >
                    <div
                      style="width: 50%;"
                    >
                      <validation-provider
                        #default="{ errors }"
                        name="Validity Year"
                        vid="validityYear"
                      >
                        <v-select
                          id="h-scheme-validityYear"
                          v-model="validityYear"
                          label="title"
                          :options="validityYears"
                          :reduce="title => title.code"
                          :clearable="false"
                          :disabled="lifeTime"
                          @input="validityYearValidation == true ? validityYearValidation = false : null"
                        />
                        <small class="text-danger">{{ errors[0] }}</small>

                        <small
                          v-if="validityYearValidation"
                          class="text-danger"
                        >
                          {{ validityYearError }}
                        </small>
                      </validation-provider>
                    </div>

                    <!-- Validity Type -->
                    <div
                      style="width: 50%;"
                    >
                      <validation-provider
                        #default="{ errors }"
                        name="Validity Type"
                        vid="validityType"
                      >
                        <v-select
                          id="h-scheme-validityType"
                          v-model="validityType"
                          label="title"
                          :options="validityTypes"
                          :reduce="title => title.code"
                          :clearable="false"
                          :disabled="lifeTime"
                          @input="validityTypeValidation == true ? validityTypeValidation = false : null"
                        />
                        <small class="text-danger">{{ errors[0] }}</small>

                        <small
                          v-if="validityTypeValidation"
                          class="text-danger"
                        >
                          {{ validityTypeError }}
                        </small>
                      </validation-provider>
                    </div>
                  </div>

                  <!-- Lifetime -->
                  <div
                    class="flex-grow-1 d-flex justify-content-start"
                    style="padding-top:8px;"
                  >
                    <b-form-checkbox
                      v-model="lifeTime"
                      class="mt-0"
                      style="white-space: nowrap;"
                    >
                      Lifetime
                    </b-form-checkbox>
                  </div>

                </div>

                <small class="small_info">
                  From date of issuance, as assigned when this entitlement is issued to a customer.
                  Customer will have this period of time to redeem/consume this entitlement.
                </small>
              </b-form-group>
            </b-col>
          </b-row>

          <b-row>
            <b-col cols="md-12">
              <b-form-group
                label="Terms & Conditions*"
                label-for="h-article-terms-condition"
                label-cols-md="2"
              >
                <div
                  class="d-flex align-items-start"
                  style="gap: 10px;"
                >
                  <div class="w-full">
                    <quill-editor
                      ref="quillTextEditor"
                      class="editor d-block"
                      :value="termsCondition"
                      :options="editorOption"
                      @change="onEditorChange"
                    />
                    <small
                      v-if="termsConditionValidation"
                      class="text-danger"
                    >
                      {{ termsConditionError }}
                    </small>
                  </div>
                </div>
              </b-form-group>
            </b-col>
          </b-row>

          <b-row>
            <b-col cols="md-12">
              <b-form-group
                label="Paid Entitlement*"
                label-for="h-activity-type-paidEntitlement"
                label-cols-md="2"
                class="cs_radio"
              >
                <validation-provider
                  #default="{ errors }"
                  name="Paid Entitlement"
                  vid="paidEntitlement"
                  rules="required"
                >
                  <b-form-radio-group
                    id="h-activity-type-paidEntitlement"
                    v-model="paidEntitlement"
                    button-variant="outline-primary"
                    buttons
                    class="spaceBetweenRadio"
                  >
                    <div
                      class="d-flex align-items-start"
                      style="gap: 10px;"
                    >
                      <div class="w-full">
                        <b-form-radio
                          v-for="(option, kindex) in requiredOptions"
                          :key="kindex"
                          :value="option.value"
                        >
                          <feather-icon
                            icon="CheckIcon"
                            class="mr-50"
                            size="16"
                          />
                          <span class="align-middle">{{ option.text }}</span>
                        </b-form-radio>
                      </div>
                    </div>
                  </b-form-radio-group>
                  <small class="text-danger">{{ errors[0] }}</small>

                  <div>
                    <small class="small_info">Because paid entitlements are items purchased by a customer and is a fulfillable item as part of a file, all paid entitlements (regardless of its status) are always displayed to the New Purchaser during a File Transfer process, e.g. even if it is “Redeemed”, “Cancelled” or “Expired”. This way, the New Purchaser can see clearly if they are missing out on any entitlements and choose not to accept the file transfer.</small>
                  </div>
                  <div
                    style="margin-top: 10px;"
                  >
                    <small class="small_info">Non-paid entitlements are only displayed to New Purchaser during a File Transfer process if they are redeemable.</small>
                  </div>
                </validation-provider>
              </b-form-group>
            </b-col>
          </b-row>
          <hr class="mt-20">
          <template
            v-if="type == 1"
          >
            <h3 class="align-middle mr-auto">
              Inventory Item Options*
            </h3>
            <p>Customers who receive this entitlement <b>will be able to choose 1 item</b> from the following linked Inventory Item(s). Identify a store to draw each item from. At least 1 inventory item needs to be selected here.</p>
            <b-row class="itemRequests_fields mb-25">
              <b-col
                class="item_field"
              >
                Item(s)*
              </b-col>
              <b-col
                class="quantity_field"
              >
                Quantity*
              </b-col>
              <b-col
                class="unit_field"
              >
                Store*
              </b-col>
              <b-col class="remove__field" />
            </b-row>
            <b-row
              v-for="(itemOption, index) in inventoryOptions"
              :id="'itemRequests' + index"
              :key="index"
              ref="row"
              class="itemRequests_fields"
            >
              <!-- Item Name -->
              <b-col class="item_field">
                <div
                  class="d-flex justify-content-between"
                >
                  <validation-provider
                    #default="{ errors }"
                    name="item"
                    :rules="type === 1 ? 'required' : ''"
                    class="w-100"
                  >
                    <v-select
                      :id="'search_name'+index"
                      v-model="itemOption.item"
                      :options="itemOptions"
                      label="name"
                      :reduce="item => item._id"
                      placeholder="Type an item name"
                      :filterable="true"
                      :clearable="false"
                      @input="updateItemOption(index)"
                    >
                      <!-- Dropdown option -->
                      <template #option="{ name: optionName, image, sku }">
                        <div class="d-flex align-items-center">
                          <b-img
                            :src="image || placeholderImage"
                            alt=""
                            class="option-img mr-1"
                          />
                          <div>
                            <div
                              class="font-weight-bold"
                            >
                              {{ optionName }}
                            </div>
                            <small class="text-muted">{{ sku }}</small>
                          </div>
                        </div>
                      </template>

                      <!-- Selected value -->
                      <template #selected-option="{ name: optionName }">
                        <div class="d-flex align-items-center">
                          <span>{{ optionName }}</span>
                        </div>
                      </template>
                      <small
                        v-if="errors.length"
                        class="text-danger"
                      >
                        {{ errors[0] }}
                      </small>
                    </v-select>
                  </validation-provider>
                  <b-img
                    class="item-img-block"
                    :src="itemOption.image ? itemOption.image : placeholderImage"
                  />
                </div>
              </b-col>

              <!-- Quantity -->
              <b-col class="quantity_field">
                <b-form-group
                  label="Quantity*"
                  :label-for="'quantity' + index"
                >
                  <validation-provider
                    #default="{ errors }"
                    name="Quantity"
                    vid="quantity"
                    :rules="type === 1 ? 'required|integer' : ''"
                  >
                    <!-- <b-form-input
                      :id="'quantity' + index"
                      v-model="itemOption.quantity"
                      type="number"
                      step="1"
                      min="0"
                      placeholder="0"
                      :state="(errors.length > 0) ? false : null"
                      name="quantity"
                    /> -->
                    <b-form-spinbutton
                      :id="'quantity' + index"
                      v-model="itemOption.quantity"
                      class="mb-md-0 mb-2 qty-spinbutton"
                      min="1"
                      max="100"
                      step="1"
                      :state="(errors.length > 0) ? false : null"
                      name="quantity"
                    >
                      <template #increment>
                        <feather-icon icon="ChevronUpIcon" />
                      </template>
                      <template #decrement>
                        <feather-icon icon="ChevronDownIcon" />
                      </template>
                    </b-form-spinbutton>
                    <small
                      v-if="errors.length"
                      class="text-danger"
                    >
                      {{ errors[0] }}
                    </small>
                  </validation-provider>
                </b-form-group>
              </b-col>

              <!-- Cost -->
              <b-col class="unit_field">
                <validation-provider
                  #default="{ errors }"
                  name="store"
                  :rules="type === 1 ? 'required' : ''"
                >
                  <b-form-group
                    label="Store*"
                    :label-for="'store' + index"
                    :state="(errors.length > 0) ? false : null"
                  >
                    <v-select
                      v-model="itemOption.store"
                      :options="storeOptions"
                      label="name"
                      placeholder="Select a store"
                      :reduce="item => item._id"
                      :clearable="false"
                    >
                      <!-- Dropdown option -->
                      <!-- <template #option="{ name: optionName, subtitle }">
                        <div class="custom-option">
                          <div class="optionName">
                            {{ optionName }}
                          </div>
                          <div class="subtitle">
                            {{ subtitle }}
                          </div>
                        </div>
                      </template> -->
                      <template #option="{ name: optionName, department }">
                        <span style="font-size: 14px;font-weight: 400;"> {{ optionName }}</span>
                        <br>
                        <span
                          style="font-weight: 500;font-size: 12px;"
                          class="text-muted"
                        >
                          {{ department.name }}
                        </span>
                      </template>

                      <!-- Selected value -->
                      <template #selected-option="{ name: selectedName }">
                        <div class="selected-option">
                          {{ selectedName }}
                        </div>
                      </template>
                    </v-select>

                    <small
                      v-if="errors.length"
                      class="text-danger"
                    >
                      {{ errors[0] }}
                    </small>
                  </b-form-group>
                </validation-provider>
              </b-col>

              <!-- Remove Button -->
              <b-col
                class="remove__field"
              >
                <b-button
                  variant="flat-primary"
                  class="mt-0 mt-md-2 primary-button-with-background no-background"
                  type="button"
                  @click="removeInventoryItem(index)"
                >
                  <feather-icon
                    icon="Trash2Icon"
                    class="mr-25"
                  />
                </b-button>
              </b-col>
            </b-row>
            <div class="add_item">
              <b-button
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                variant="primary"
                @click="addInventoryItem"
              >
                <feather-icon
                  icon="PlusIcon"
                  class="mr-25"
                />
                <span>Add Inventory Item Option</span>
              </b-button>
            </div>
          </template>
        </b-card>

        <b-nav class="wrap-border save-nav">
          <li
            class="nav-item ml-auto"
          >
            <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              type="button"
              variant="flat-primary"
              @click="goBackToScheme()"
            >
              Cancel
            </b-button>
          </li>
          <li
            class="nav-item mr-1"
          >
            <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              type="submit"
              variant="success"
              :disabled="invalid"
            >
              <feather-icon
                icon="PlusIcon"
                class="mr-50"
              />
              <span class="align-middle">Save Changes</span>
            </b-button>
          </li>
        </b-nav>
      </validation-observer>
    </b-form>
  </div>
</template>

<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import {
  BCard, BRow, BCol, BFormGroup, BFormInput, BForm, BButton, BNav, BFormCheckbox, BFormRadio,
  BFormRadioGroup, BImg, BFormSpinbutton,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import vSelect from 'vue-select'
import 'vue2-dropzone/dist/vue2Dropzone.min.css'
import { required } from '@validations'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import { quillEditor } from 'vue-quill-editor'
import '@core/scss/vue/libs/vue-flatpicker.scss'
import ToastificationContentCustom from '../../operation/ToastificationContentCustom.vue'

export default {
  components: {
    BCard,
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BForm,
    BButton,
    BNav,
    BFormCheckbox,
    BFormRadio,
    BFormRadioGroup,
    BImg,
    BFormSpinbutton,

    vSelect,
    // eslint-disable-next-line vue/no-unused-components
    ToastificationContent,
    ValidationProvider,
    ValidationObserver,
    quillEditor,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      existScheme: {},
      name: '',
      termsCondition: '',
      type: '',
      funeralServicePackage: '',
      lifeTime: false,
      validityYear: 1,
      validityType: 'Years',
      nameError: 'Scheme Name is required',
      termsConditionError: 'Internal Remarks is required',
      nameValidation: false,
      termsConditionValidation: false,
      typeValidation: false,
      typeError: 'Valid Entitlement Item Type is required',
      funeralServicePackageValidation: false,
      funeralServicePackageError: 'Valid Funeral Service Package is required',
      validityYearError: 'Valid Year is required',
      validityYearValidation: false,
      validityTypeError: 'Valid Type is required',
      validityTypeValidation: false,
      paidEntitlement: 'yes',
      itemOptions: [],
      requiredOptions: [
        { text: 'Yes', value: 'yes' },
        { text: 'No', value: 'no' },
      ],
      itemTypes: [
        { title: 'Inventory-managed item', code: 1 },
        { title: 'Funeral Service Package', code: 2 },
        { title: 'Non-inventory-managed item', code: 3 },
      ],
      // storeOptions: [
      //   { name: 'Main Store', subtitle: 'Nirvana Singapore', code: 'Main Store' },
      //   { name: 'Block A', subtitle: 'Nirvana Memorial Garden', code: 'Block A' },
      //   { name: 'Block B', subtitle: 'Nirvana Memorial Garden', code: 'Block B' },
      //   { name: 'Block C', subtitle: 'Nirvana Memorial Garden', code: 'Block C' },
      //   { name: 'Block D', subtitle: 'Mount Prajna Pte. Ltd.', code: 'Block D' },
      //   { name: 'Block E', subtitle: 'Mount Prajna Pte. Ltd.', code: 'Block E' },
      // ],
      storeOptions: [],
      funeralServicePackages: [
        { title: 'NV Longevity', code: 1 },
      ],
      validityTypes: [
        { title: 'Month', code: 'Month' },
        { title: 'Years', code: 'Years' },
      ],
      inventoryOptions: [{
        item: '',
        image: '',
        quantity: 1,
        store: '',
      }],
      inputTypeOptions: [
        { title: 'A Sales Order is approved', code: 'A Sales Order is approved' },
      ],
      // eslint-disable-next-line global-require
      placeholderImage: require('@/assets/images/placeholder/placeholder_image.png'),
      // validation rules
      required,
      validityYears: Array.from({ length: 9 }, (_, i) => ({
        title: (i + 1).toString(),
        code: i + 1,
      })),
    }
  },

  async beforeMount() {
    this.$http.get('inventory/store/respond-with/name-and-id')
      .then(response => {
        this.storeOptions = response.data.stores
      })
      .catch(error => {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: error.data.message ?? process.env.VUE_APP_DEFAULT_ERROR_MESSAGE,
            icon: 'AlertTriangleIcon',
            variant: 'danger',
          },
        })
      })
    await this.$http.get('inventory/item/respond-with/name-and-id')
      .then(response => {
        this.itemOptions = response.data.stores
      })
      .catch(error => {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: error.data.message ?? process.env.VUE_APP_DEFAULT_ERROR_MESSAGE,
            icon: 'AlertTriangleIcon',
            variant: 'danger',
          },
        })
      })

    this.$http.get(`reservation/entitlement-scheme-items/${this.$route.params.id}`)
      .then(response => {
        this.existScheme = response.data
        this.name = response.data.name
        this.type = response.data.type
        this.funeralServicePackage = response.data.funeralServicePackage
        this.termsCondition = response.data.termsCondition
        this.lifeTime = !!response.data.lifeTime
        this.validityYear = response.data.validityYear
        this.validityType = response.data.validityType
        this.paidEntitlement = response.data.paidEntitlement
        this.inventoryOptions = response.data.inventoryOptions.map(item => {
          // eslint-disable-next-line eqeqeq
          const inventoryItem = this.itemOptions.find(itemOption => itemOption._id == item.item)
          return {
            item: item.item,
            image: inventoryItem ? inventoryItem.image : null,
            quantity: item.quantity,
            store: item.store,
          }
        })
      })
      .catch(error => {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: error.data.message ?? process.env.VUE_APP_DEFAULT_ERROR_MESSAGE,
            icon: 'AlertTriangleIcon',
            variant: 'danger',
          },
        })
      })
  },

  methods: {
    removeInventoryItem(index) {
      if (this.inventoryOptions.length > 1) {
        this.inventoryOptions.splice(index, 1)
      } else {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'This have to have atleast one row.',
            icon: 'BellIcon',
            variant: 'warning',
          },
        })
      }
    },
    addInventoryItem() {
      this.inventoryOptions.push({
        item: '',
        image: '',
        quantity: 1,
        store: '',
      })
    },
    onEditorChange(value) {
      this.termsCondition = value.html
    },
    submitForm() {
      this.$refs.schemeCreateForm.validate().then(success => {
        if (success) {
          const formData = new FormData()
          formData.append('name', this.name)
          formData.append('type', this.type)
          formData.append('validityYear', this.validityYear)
          formData.append('validityType', this.validityType)
          formData.append('termsCondition', this.termsCondition)
          formData.append('paidEntitlement', this.paidEntitlement)
          if (this.lifeTime) {
            formData.append('lifeTime', this.lifeTime)
          }
          if (this.type === 1) {
            const trimmedData = this.inventoryOptions.map(field => {
              const properties = {
                item: field.item,
                quantity: field.quantity,
                store: field.store,
              }
              return properties
            })
            formData.append('inventoryOptions', JSON.stringify(trimmedData))
          } else if (this.type === 2) {
            formData.append('funeralServicePackage', this.funeralServicePackage)
          }

          this.$http.patch(`reservation/entitlement-scheme-items/${this.$route.params.id}/update`, formData)
            .then(() => {
              const toastMessage = `Entitlement Item to be Issued - "<span class="text-bold-black">${this.name}</span>" has been successfully updated.`
              this.$toast({
                component: ToastificationContentCustom,
                props: {
                  title: 'Changes saved!',
                  text: toastMessage,
                  icon: 'CheckCircleIcon',
                  variant: 'success',
                  hideClose: true,
                },
              })
              this.$router.push({ name: 'products-schemes-show', params: { id: this.existScheme.entitlementScheme } })
            })
            .catch(error => {
              if (error.data.errors) {
                error.data.errors.forEach(validationError => {
                  if (validationError.param === 'name') {
                    this.nameError = validationError.msg
                    this.nameValidation = true
                  } else if (validationError.param === 'type') {
                    this.typeError = validationError.msg
                    this.typeValidation = true
                  } else if (validationError.param === 'funeralServicePackage') {
                    this.funeralServicePackageError = validationError.msg
                    this.funeralServicePackageValidation = true
                  } else if (validationError.param === 'validityYear') {
                    this.validityYearError = validationError.msg
                    this.validityYearValidation = true
                  } else if (validationError.param === 'validityType') {
                    this.validityTypeError = validationError.msg
                    this.validityTypeValidation = true
                  } else if (validationError.param === 'termsCondition') {
                    this.termsConditionError = validationError.msg
                    this.termsConditionValidation = true
                  }
                })

                const items = document.getElementsByClassName('text-danger')
                window.scrollTo({
                  top: items[0].offsetTop,
                  behavior: 'smooth',
                })
              } else {
                this.$toast({
                  component: ToastificationContent,
                  props: {
                    title: error.data.message ?? process.env.VUE_APP_DEFAULT_ERROR_MESSAGE,
                    icon: 'AlertTriangleIcon',
                    variant: 'danger',
                  },
                })
              }
            })
        }
      })
    },
    goBackToScheme() {
      this.$router.push({ name: 'products-schemes-show', params: { id: this.existScheme.entitlementScheme } })
    },
    updateItemOption(index) {
      const option = this.itemOptions.find(item => item._id === this.inventoryOptions[index].item)
      // this.inventoryOptions[index].image = option.image ? option.image : null
      this.$set(this.inventoryOptions[index], 'image', option.image ? option.image : null)
    },
  },
  setup() {
    const editorOption = {
      modules: {
        // toolbar: '#quill-editor',
        toolbar: [
          ['bold', 'italic', 'underline'],
          // ['blockquote', 'code-block'],
          [{ header: 1 }, { header: 2 }],
          [{ list: 'ordered' }, { list: 'bullet' }],
          // [{ script: 'sub' }, { script: 'super' }],
          // [{ indent: '-1' }, { indent: '+1' }],
          // [{ direction: 'rtl' }],
          // [{ size: ['small', false, 'large', 'huge'] }],
          // [{ header: [1, 2, 3, 4, 5, 6, false] }],
          // [{ font: [] }],
          // [{ color: [] }, { background: [] }],
          // [{ align: [] }],
          // ['clean'],
          // ['link', 'image', 'video'],
          ['link'],
        ],
      },
      theme: 'snow',
      placeholder: '',
    }

    return {
      editorOption,
    }
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
@import '@core/scss/vue/libs/quill.scss';

.qty-spinbutton {
  display: grid !important;
  grid-template-columns: 1fr auto;
  grid-template-rows: 1fr 1fr;
  padding: 0;

  output {
    grid-column: 1;
    grid-row: 1 / 3;
    display: flex;
    align-items: center;
    padding-left: 0.5rem;
    border-left: none !important;
    border-right: none !important;
  }

  button:last-child {
    grid-column: 2;
    grid-row: 1;
    border: none !important;
    padding: 2px 6px 1px 6px;
    color: var(--primary) !important;
    align-self: end;
    line-height: 1;
  }

  button:first-child {
    grid-column: 2;
    grid-row: 2;
    border: none !important;
    padding: 1px 6px 2px 6px;
    color: var(--primary) !important;
    align-self: start;
    line-height: 1;
  }

  button svg {
    width: 14px;
    height: 14px;
    display: block;
  }
}
</style>

<style scoped>
.inlineElement {
  display: flex;
  align-items: center;
  gap: 12px;
}
.editor {
  min-height: 320px;
  overflow: hidden;
  border: 1px solid #D2DCEA;
  border-radius: 5px;
}
.custom-option {
  display: flex;
  flex-direction: column;
}

.custom-option .title {
  font-weight: 500;
  font-size: 14px;
  color: #2c2c2c;
}

.custom-option .subtitle {
  font-size: 12px;
  color: #9aa0a6;
}

.vs__dropdown-option--highlight {
  background-color: #1f3bb3 !important;
  color: white;
}

.vs__dropdown-option--highlight .subtitle {
  color: rgba(255,255,255,0.7);
}
</style>
